import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import burger from '../blocks/burger/burger.js';
import entryCarousel from '../blocks/entry-carousel/entry-carousel.js';
import carouselNavigation from '../blocks/carousel-navigation/carousel-navigation.js';
import customScrollbar from '../blocks/custom-scrollbar/custom-scrollbar.js';
import postersCarousel from '../blocks/posters-carousel/posters-carousel.js';
import content from '../blocks/content/content.js';

$(() => {
	svg4everybody();
	burger();
	entryCarousel();
	carouselNavigation();
	customScrollbar();
	postersCarousel();
	content();
});



// WEBPACK FOOTER //
// ./app/scripts/app.js